export const getDatetime = ({ date, time }: { date: string; time: string }) => {
  const datetime = new Date(date);
  const [hours, minutes] = time.split(":");
  datetime.setHours(parseInt(hours));
  datetime.setMinutes(parseInt(minutes));

  return datetime;
};
